import {
	FileExcelOutlined,
	FileImageOutlined,
	FilePdfOutlined,
	FilePptOutlined,
	FileTextOutlined,
	FileWordOutlined,
	FileZipOutlined,
	FileOutlined,
	FolderOutlined,
} from "@ant-design/icons";

// Icon mapping based on file extension
export const fileIcons: Record<string, React.ReactNode> = {
	// Documents
	docx: <FileWordOutlined style={{ fontSize: 20 }} />,
	doc: <FileWordOutlined style={{ fontSize: 20 }} />,
	pdf: <FilePdfOutlined style={{ fontSize: 20 }} />,
	txt: <FileTextOutlined style={{ fontSize: 20 }} />,
	rtf: <FileTextOutlined style={{ fontSize: 20 }} />,
	// Spreadsheets
	xlsx: <FileExcelOutlined style={{ fontSize: 20 }} />,
	xls: <FileExcelOutlined style={{ fontSize: 20 }} />,
	csv: <FileExcelOutlined style={{ fontSize: 20 }} />,
	// Presentations
	pptx: <FilePptOutlined style={{ fontSize: 20 }} />,
	ppt: <FilePptOutlined style={{ fontSize: 20 }} />,
	// Images
	png: <FileImageOutlined style={{ fontSize: 20 }} />,
	jpg: <FileImageOutlined style={{ fontSize: 20 }} />,
	jpeg: <FileImageOutlined style={{ fontSize: 20 }} />,
	gif: <FileImageOutlined style={{ fontSize: 20 }} />,
	bmp: <FileImageOutlined style={{ fontSize: 20 }} />,
	tiff: <FileImageOutlined style={{ fontSize: 20 }} />,
	ico: <FileImageOutlined style={{ fontSize: 20 }} />,
	webp: <FileImageOutlined style={{ fontSize: 20 }} />,
	svg: <FileImageOutlined style={{ fontSize: 20 }} />,
	// Archives
	zip: <FileZipOutlined style={{ fontSize: 20 }} />,
	rar: <FileZipOutlined style={{ fontSize: 20 }} />,
	"7z": <FileZipOutlined style={{ fontSize: 20 }} />,
	tar: <FileZipOutlined style={{ fontSize: 20 }} />,
	gz: <FileZipOutlined style={{ fontSize: 20 }} />,
	// Default
	default: <FileOutlined style={{ fontSize: 20 }} />,
	folder: <FolderOutlined style={{ fontSize: 20 }} />,
};

// Get file extension from filename
export const getFileExtension = (filename?: string): string => {
	if (!filename) return "";
	const lastDot = filename.lastIndexOf(".");
	if (lastDot === -1 || lastDot === filename.length - 1) return "";
	return filename.slice(lastDot + 1).toLowerCase();
};

// Get icon for a file based on its name
export const getFileIcon = (
	filename?: string,
	isFolder?: boolean
): React.ReactNode => {
	if (isFolder) return fileIcons["folder"];
	const ext = getFileExtension(filename);
	return fileIcons[ext] || fileIcons["default"];
};
